/*
*
* @module : TopicService
* @file : TopicService.js 
* @author : Abhishek Bhatt
* @summary : This file contains the all function of TopicService
*
* Created on : 09-Oct-2019
* @Last Modified by : Abhishek Bhatt
* @Last Modified time : 19-Oct-2019
*/

import axios from 'axios';
const API_URL = 'https://quiz.wanitsch.ch/quiz/quiz_app.php';

class TopicService
{
	async getAllTopic()
	{
		const url = `${API_URL}`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		let formData  = new FormData();
		formData.append('token','');
		formData.append('command','topics');
		return axios({
			url:url,
			method: 'post',
			data: formData,
			config:{headers:headers}
		}).then(function(response) {
			return response.data;
		}).catch(function(response) {
			return response;
		});
	}

	async addTopic(topic_id)
	{
		const url = `${API_URL}`;
		const headers = {
			'Content-Type':'multipart/form-data'
		}
		let session_id = sessionStorage.getItem('session_id');
		let formData  = new FormData();
		formData.append('token','');
		formData.append('command','add_topic');
		formData.append('topic_id',topic_id);
		formData.append('session_id',session_id);
		return axios({
			url:url,
			method: 'post',
			data: formData,
			config:{headers:headers}
		}).then(function(response) {
			return response.data;
		}).catch(function(response) {
			return response;
		});
	}

}

export default TopicService;